export const CONFIGS = {
  NUMBER_OF_ITEMS_IN_ROW: 4,
  PAGE_SIZE: 48,
};

export const BUTTON_TEXT = {
  LOADING: 'Loading',
  LOAD_MORE: 'Load More',
};
